export default __webpack_public_path__ + "static/media/106_desktop.aba09823.jpg";